<p-picklist
  [source]="this.sourceItems"
  [target]="this.targetItems"
  [dragdrop]="false"
  [metaKeySelection]="false"
  [disabled]="this.disabled()"
  [showSourceControls]="false"
  [showTargetControls]="false"
  [sourceStyle]="{'height': '250px'}"
  [targetStyle]="{'height': '250px'}"
  [moveAllToTargetProps]="{ styleClass: 'd-none' }"
  [moveAllToSourceProps]="{ styleClass: 'd-none' }"
  (onMoveToTarget)="this.onMoveToTarget($event)"
  (onMoveAllToTarget)="this.onMoveAllToTarget($event)"
  (onMoveToSource)="this.onMoveToSource($event)"
  (onMoveAllToSource)="this.onMoveAllToSource($event)"
>
  <ng-template
    #item
    let-item
  >
    {{ this.getItemLabel(item) }}
  </ng-template>
</p-picklist>